import React, { useState, useEffect } from "react";

import { t } from "i18next";
import { Trans } from "react-i18next";
import { Link, useHistory } from "react-router-dom";

import SubscriptionPlansCards from "../../components/Cards/SubscriptionPlansCards";
import { fetchLoggedUser } from "../../utils/UserHelper";
import { isAuthorized } from "../../utils/RolesHelpers";
import { ROLES } from "../../utils/constants";
import Navbar from "../../components/Navbars/Navbar";

const LicenseExpirationView = () => {
    const [currentUser, setCurrentUser] = useState({});
    const history = useHistory();

    useEffect(() => {
        fetchLoggedUser(setCurrentUser);

        return () => {
            setCurrentUser({});
        };
    }, []);

    useEffect(() => {
        if (currentUser && isLicenseValid(currentUser))
            history.push("/dashboard");
    }, [currentUser]);

    const isAuthorizedToPay = () => {
        return isAuthorized(
            [ROLES.partnerAdmin, ROLES.support],
            [currentUser?.role]
        );
    };

    const isLicenseValid = (user) => {
        return (
            user?.organization?.isLicenseValid || user.role === ROLES.superAdmin
        );
    };

    const isAccessRestricted = () => {
        const userOrganization = currentUser?.organization;
        return (
            !userOrganization?.isLicenseValid &&
            !userOrganization?.isLicenseInExtendedPeriod
        );
    };

    const getExpirationMessage = () => {
        return t(
            isAuthorizedToPay()
                ? "licenseExpiredWithNoExtension"
                : "licenseExpiredInferiorUser"
        );
    };

    return (
        <>
            <Navbar
                currentUser={currentUser}
                isRestricted={isAccessRestricted()}
            />
            <div className="main-content w-full m-0">
                <div className="flex flex-col w-full w-full justify-center items-center gap-5">
                    <div className="w-1/6 h-1/6">
                        <img
                            src={
                                require("../../assets/images/calendar.png")
                                    .default
                            }
                        />
                    </div>
                    <div className="flex flex-col justify-center items-center gap-2">
                        <h3 className="text-primary-color-orange text-3xl">
                            <Trans i18nKey="licenseExpired">
                                License Expired
                            </Trans>
                        </h3>
                        <p className="text-primary-color-blue text-md text-center">
                            {getExpirationMessage()}
                            {!isAccessRestricted() && (
                                <Trans i18nKey="licenseExpiredGetBackToDashboard">
                                    or continue using NeoSpectra platform
                                    <Link
                                        className="underline text-blue-600"
                                        to="/dashboard"
                                    >
                                        click here
                                    </Link>
                                </Trans>
                            )}
                        </p>
                    </div>
                    {isAuthorizedToPay() && (
                        <SubscriptionPlansCards
                            currentUser={currentUser}
                            setCurrentUser={setCurrentUser}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default LicenseExpirationView;
